import { combineReducers } from 'redux'

import { currenciesMetaReducer } from 'components/features/rewards/rewardsPane/store/reducers/currenciesMeta'
import { currenciesStatisticsReducer } from 'components/features/rewards/rewardsPane/store/reducers/currenciesStatistics'
import { ordersResultsReducer } from 'components/features/rewards/rewardsPane/store/reducers/ordersResults'
import { cryptoRewardsReducer } from 'components/features/rewards/rewardsPane/store/reducers/cryptoRewardsReducer'
import { CryptoRewardsPaneReducer } from 'components/features/rewards/rewardsPane/types/store'
import { CryptoRewardsPaneMode } from 'components/features/rewards/rewardsPane/types/paneState'

export const cryptoRewardsPaneReducer = combineReducers<CryptoRewardsPaneReducer<CryptoRewardsPaneMode>>({
  currenciesMeta: currenciesMetaReducer,
  currenciesStatistics: currenciesStatisticsReducer,
  ordersResults: ordersResultsReducer,
  cryptoRewards: cryptoRewardsReducer,
})
